import {Logger} from './Logger'
import {isArray, findIndex, round} from 'lodash';

export type StringOrObject = string | Object;
declare var autosize: any;
declare var UUID: any;

export class Utils {
    public static focusControl(selector: string | JQuery, delayed?: boolean): void {
        delayed = Utils.valueOrDefault(delayed, true);

        var ctrl: JQuery = selector instanceof jQuery ? selector : Utils.getJQueryById(selector as string) as any;

        if (delayed) {
            setTimeout(() => {
                    //var ctrl = Utils.getJQueryById(selector);
                    ctrl.focus();
                },
                100);
        } else {
            //var ctrl = Utils.getJQueryById(selector);
            ctrl.focus();
        }
    }

    public static makeAutosizeEdit(selector: string | JQuery): void {
        var ctrl: JQuery = selector instanceof jQuery ? selector : Utils.getJQueryById(selector as string) as any;
        if (ctrl && autosize) {
            autosize(ctrl);
        }
    }

    public static getJQueryById(id: string): JQuery {
        if (typeof id !== 'string') {
            throw new Error('id must be type of string.');
        }

        if (!_.startsWith(id, '#')) {
            id = '#' + id;
        }

        return $(id);
    }

    public static isNullOrUndefined(obj: any): boolean {
        return obj === undefined || obj === null;
    }

    public static asNumber(value: string | number | boolean): number {
        var type = typeof value;

        if (type === 'string') {
            return Number(value);
        } else if (type === 'number') {
            return value as number;
        } else if (type === 'boolean') {
            return value === true ? 1 : 0;
        }

        return NaN;
    }

    public static valueIsIn<T>(value: any, array: Array<T>): boolean {
        if (isArray(array)) {
            return findIndex(array, (item: any) => value === item) > -1;
        }

        return false;
    }

    public static tryParseNumber(value: any): { value: number, isValid: boolean } {
        var result = Utils.asNumber(value);
        return {
            value: result,
            isValid: !isNaN(result)
        };
    }

    public static formatNumber(value: string | number | boolean, fractionDigits?: number): string {
        var number = Utils.asNumber(value);
        fractionDigits = Utils.valueOrDefault(fractionDigits, 0);
        return number.toFixed(fractionDigits);
    }

    public static tryParseJson(value: StringOrObject, logError?: boolean): Object {
        var result = Utils.parseJson(value, logError);
        return result.json;
    }

    public static parseJson(value: StringOrObject, logError?: boolean): { json?: Object, isValid: boolean } {

        var result: { json?: Object, isValid: boolean } = {
            json: undefined,
            isValid: false
        };

        if (typeof value === 'string') {
            if (value !== undefined && value !== null && value !== '') {
                try {
                    result.json = JSON.parse(value);
                } catch (e) {
                    logError = Utils.valueOrDefault(logError, true);

                    if (logError === true) {
                        Logger.debug('[parseJson] failed for string: ' + value);
                    }
                }
            }
        }
        else if (typeof value === 'object') {
            result.json = value;
        }

        result.isValid = !this.isNullOrUndefined(result.json);
        return result;
    }

    public static valueOrDefault<T>(value: any, defaultValue: T): T {
        var result = Utils.isNullOrUndefined(value)
            ? defaultValue
            : value as T;

        var t = typeof defaultValue;
        if (t === 'boolean') {
            result = <any>Utils.asBool(result);//value); > bugfix
        }

        return result;
    }

    public static getURIQuery(): Object {
        return URI().query(true);
    }

    public static asBool(value: any): boolean {
        var t = typeof value;
        if (t === 'boolean') {
            return value;
        }

        if (t === 'number') {
            var n = value as number;
            return n > 0;
        }

        if (t === 'string') {
            var s = (value as string).toLowerCase();
            return s === 'true';
        }

        return false;
    }

    public static getErrorMsg(error: Error | string): string {
        if (error instanceof Error) {
            return (error as Error).message;
        }

        return error as string;
    }

    public static calcPercentage(value: number, total: number, roundPrecision?: number): number {
        var result = total === 0 ? 0 : (value / total) * 100.00;
        roundPrecision = this.valueOrDefault(roundPrecision, null);
        if (!this.isNullOrUndefined(roundPrecision)) {
            result = round(result, roundPrecision);
        }

        return result;
    }

    public static generateUuid(hexNoDelim: boolean = null): string {
        hexNoDelim = Utils.valueOrDefault(hexNoDelim, false);
        var uuid = UUID.generate();
        if (hexNoDelim) {
            uuid = uuid.replace(/-/gi, '');
        }

        return uuid;
    }

    public static toggleShow(jqElement: JQuery, show: boolean): void {
        if (show) {
            jqElement.show();
        } else {
            jqElement.hide();
        }
    }

    public static scrollToTop() {
        window.scrollTo(0, 0);
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Utils/Utils.ts
 **/